export enum KAMPFKUNST_FEATURE_ID {
  Atmung = 'atmung',
  BeladenUeberspielen = 'beladen-ueberspielen',
  Gesundheit = 'gesundheit',
  GrunduebungenFallschule = 'grunduebungen-fallschule',
  Hebel = 'hebel',
  NervendruckVitalpunkte = 'nervendruck-vitalpunkte',
  Schlaege = 'schlaege',
  Wuerfe = 'wuerfe',
}
